import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOrderingUnchecked = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		x: 1,
		y: 1,
		width: 10,
		height: 10,
		rx: 5,
		stroke: "#D0DFE4",
		strokeWidth: 2
	})
});
export default SvgOrderingUnchecked;
